export default "__VITE_PUBLIC_ASSET__375f9af7__"